<template>
  <div class="wrapper">
    <Navbar />

    <div
      v-if="$route.name !== 'Top Page' || $route.name !== 'Login'"
      class="contents-ttl container-xl"
    >
      <Breadcrumb v-if="crumbs.length" :crumbs="crumbs" />

      <div
        v-if="headingTitle || $slots['button-area'] || $slots['heading']"
        class="main-ttl container-xl"
      >
        <h2 v-if="headingTitle && !$slots['heading']">
          <span>{{ headingTitle }}</span>
          <small>{{ headingDesc }}</small>
        </h2>

        <slot name="heading"></slot>

        <div v-if="$slots['button-area']" class="btn-area">
          <slot name="button-area"></slot>
        </div>
      </div>
    </div>

    <slot></slot>

    <Footer />
  </div>
</template>

<script>
import { Breadcrumb } from "components";

import Footer from "./Footer.vue";
import Navbar from "./Navbar.vue";

export default {
  name: "Container",
  components: {
    Footer,
    Navbar,
    Breadcrumb,
  },
  props: {
    headingTitle: {
      type: String,
      default: "",
    },
    headingDesc: {
      type: String,
      default: "",
    },
    crumbs: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
